









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ResponsibleTodos extends Vue {
  @Prop()
  todo?: any;

  @Prop()
  index?: number;

  goToTodo() {
    if (this.todo.cutoverplan_id) {
      this.$router.push({ path: `/cutoverplan/${this.todo.id}` });
    }
  }
}
